export interface MinMaxDates {
  minStartDatetime: string | Date;
  minFinishDatetime: string | Date;
  maxStartDatetime: string | Date;
  maxFinishDatetime: string | Date;
}
